(function () {
  if (window.__mtInit) return;
  window.__mtInit = true;

  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* Reveals al hacer scroll (un solo observer compartido) */
  var io = ('IntersectionObserver' in window) ? new IntersectionObserver(function (entries) {
    entries.forEach(function (e) {
      if (e.isIntersecting) { e.target.classList.add('mt-visible'); io.unobserve(e.target); }
    });
  }, { threshold: 0.15, rootMargin: '0px 0px -40px 0px' }) : null;

  function initReveals(root) {
    root.querySelectorAll('.mt-reveal:not([data-mt-init])').forEach(function (el) {
      el.dataset.mtInit = '1';
      if (!io || reduce) { el.classList.add('mt-visible'); return; }
      io.observe(el);
    });
  }

  /* Hero: zoom-out + textos escalonados */
  function initHero(root) {
    root.querySelectorAll('.mt-hero:not([data-mt-init])').forEach(function (hero) {
      hero.dataset.mtInit = '1';
      var img = hero.querySelector('.mt-hero__media img');
      var go = function () { requestAnimationFrame(function () { hero.classList.add('mt-loaded'); }); };
      if (!img || img.complete || reduce) { go(); } else { img.addEventListener('load', go); img.addEventListener('error', go); setTimeout(go, 1500); }
    });
  }

  /* Pasos con pestañas y autoplay */
  function initSteps(root) {
    root.querySelectorAll('.mt-steps:not([data-mt-init])').forEach(function (box) {
      box.dataset.mtInit = '1';
      var tabs = Array.prototype.slice.call(box.querySelectorAll('.mt-steps__tab'));
      var imgs = Array.prototype.slice.call(box.querySelectorAll('.mt-steps__img'));
      var badge = box.querySelector('.mt-steps__badge');
      if (!tabs.length) return;
      var ms = parseInt(box.dataset.interval || '5000', 10);
      var autoplay = box.dataset.autoplay === 'true' && !reduce;
      var current = 0, timer = null;
      box.style.setProperty('--mt-step-ms', ms + 'ms');
      function show(i) {
        current = i;
        tabs.forEach(function (t, n) {
          var on = n === i;
          t.classList.toggle('is-active', on);
          t.setAttribute('aria-selected', on ? 'true' : 'false');
          var bar = t.querySelector('.mt-steps__bar');
          if (bar && on) { bar.style.animation = 'none'; void bar.offsetWidth; bar.style.animation = ''; }
        });
        imgs.forEach(function (im, n) { im.classList.toggle('is-active', n === i); });
        if (badge && tabs[i]) badge.textContent = tabs[i].dataset.badge || '';
      }
      function schedule() {
        clearTimeout(timer);
        if (!autoplay) return;
        timer = setTimeout(function () { show((current + 1) % tabs.length); schedule(); }, ms);
      }
      /* Al pulsar un paso se muestra ese y el autoplay sigue desde ahí */
      var hovering = false;
      tabs.forEach(function (t, n) {
        t.addEventListener('click', function () { show(n); if (!hovering) schedule(); });
      });
      /* Pausa solo con ratón real y solo encima de la lista de pasos (antes: toda la sección,
         que en escritorio ocupa casi la pantalla y en móvil se quedaba pausada al tocar) */
      var list = box.querySelector('.mt-steps__tabs');
      if (list && window.matchMedia('(hover: hover) and (pointer: fine)').matches) {
        list.addEventListener('mouseenter', function () { hovering = true; if (autoplay) { clearTimeout(timer); box.classList.add('is-paused'); } });
        list.addEventListener('mouseleave', function () { hovering = false; if (autoplay) { box.classList.remove('is-paused'); show(current); schedule(); } });
      }
      show(0);
      if (io && autoplay) {
        var started = false;
        var so = new IntersectionObserver(function (en) {
          if (en[0].isIntersecting && !started) { started = true; show(0); schedule(); so.disconnect(); }
        }, { threshold: 0.3 });
        so.observe(box);
      } else { schedule(); }
    });
  }

  /* FAQ desplegable */
  function initFaq(root) {
    root.querySelectorAll('.mt-faq__q:not([data-mt-init])').forEach(function (btn) {
      btn.dataset.mtInit = '1';
      btn.addEventListener('click', function () {
        var item = btn.closest('.mt-faq__item');
        var open = !item.classList.contains('is-open');
        item.classList.toggle('is-open', open);
        btn.setAttribute('aria-expanded', open ? 'true' : 'false');
      });
    });
  }

  /* Galería de producto */
  function initGallery(root) {
    root.querySelectorAll('.mt-pdp__gallery:not([data-mt-init])').forEach(function (g) {
      g.dataset.mtInit = '1';
      var slides = Array.prototype.slice.call(g.querySelectorAll('.mt-pdp__slide'));
      var thumbs = Array.prototype.slice.call(g.querySelectorAll('.mt-pdp__thumb'));
      var counter = g.querySelector('.mt-pdp__counter');
      if (slides.length < 2) return;
      var cur = 0;
      /* Fotos 2+: se descargan solo cuando el cliente desliza o toca una miniatura (más la siguiente, para que el paso sea fluido) */
      function hydrate(img) {
        if (!img || !img.dataset || !img.dataset.mtSrc) return;
        var mobile = window.matchMedia('(max-width: 749px)').matches;
        img.sizes = mobile ? 'calc(100vw - 36px)' : '(max-width: 989px) calc(100vw - 48px), 58vw';
        img.srcset = mobile ? img.dataset.mtSrcsetM : img.dataset.mtSrcsetD;
        img.src = img.dataset.mtSrc;
        delete img.dataset.mtSrc;
      }
      function go(i) {
        cur = (i + slides.length) % slides.length;
        hydrate(slides[cur]);
        hydrate(slides[(cur + 1) % slides.length]);
        slides.forEach(function (s, n) { s.classList.toggle('is-active', n === cur); s.setAttribute('aria-hidden', n === cur ? 'false' : 'true'); });
        thumbs.forEach(function (t, n) { t.classList.toggle('is-active', n === cur); t.setAttribute('aria-current', n === cur ? 'true' : 'false'); });
        if (counter) counter.textContent = (cur + 1) + ' / ' + slides.length;
        var at = thumbs[cur];
        if (at && at.parentNode.scrollWidth > at.parentNode.clientWidth) {
          at.parentNode.scrollTo({ left: at.offsetLeft - at.parentNode.clientWidth / 2 + at.clientWidth / 2, behavior: 'smooth' });
        }
      }
      thumbs.forEach(function (t, n) { t.addEventListener('click', function () { go(n); }); });
      var prev = g.querySelector('.mt-pdp__arrow--prev'), next = g.querySelector('.mt-pdp__arrow--next');
      if (prev) prev.addEventListener('click', function () { go(cur - 1); });
      if (next) next.addEventListener('click', function () { go(cur + 1); });
      /* Deslizar con el dedo */
      var main = g.querySelector('.mt-pdp__main'), x0 = null;
      if (main) {
        main.addEventListener('touchstart', function (e) { x0 = e.touches[0].clientX; }, { passive: true });
        main.addEventListener('touchend', function (e) {
          if (x0 === null) return;
          var dx = e.changedTouches[0].clientX - x0; x0 = null;
          if (Math.abs(dx) > 40) go(dx < 0 ? cur + 1 : cur - 1);
        });
      }
    });
  }

  /* Selector de oferta (1 unidad / pack de 2) + barra de compra fija en móvil */
  function initOffer(root) {
    root.querySelectorAll('.mt-pdp:not([data-mt-init])').forEach(function (pdp) {
      pdp.dataset.mtInit = '1';
      var form = pdp.querySelector('.mt-pdp__form');
      if (!form) return;
      var qty = form.querySelector('input[name="quantity"]');
      var opts = Array.prototype.slice.call(pdp.querySelectorAll('.mt-offer__opt'));
      var priceEl = pdp.querySelector('[data-mt-price]');
      var noteEl = pdp.querySelector('[data-mt-price-note]');
      var stickyPrice = pdp.querySelector('[data-mt-sticky-price]');
      function pick(opt) {
        var input = opt.querySelector('input');
        input.checked = true;
        opts.forEach(function (o) { o.classList.toggle('is-selected', o === opt); });
        if (qty) qty.value = input.value;
        if (priceEl) priceEl.textContent = opt.dataset.total;
        if (noteEl) noteEl.textContent = opt.dataset.note || '';
        if (stickyPrice) stickyPrice.textContent = opt.dataset.label + ' · ' + opt.dataset.total;
      }
      opts.forEach(function (o) {
        o.querySelector('input').addEventListener('change', function () { pick(o); });
      });
      var checked = pdp.querySelector('.mt-offer__opt input:checked');
      if (checked) pick(checked.closest('.mt-offer__opt'));

      /* ?qty=2 en el enlace preselecciona el pack */
      var m = location.search.match(/[?&]qty=(\d+)/);
      if (m) { opts.forEach(function (o) { if (o.querySelector('input').value === m[1]) pick(o); }); }

      form.addEventListener('submit', function () {
        var b = form.querySelector('.mt-pdp__atc');
        if (b) { b.setAttribute('aria-busy', 'true'); }
      });

      var sticky = pdp.querySelector('.mt-sticky-atc');
      var atc = pdp.querySelector('.mt-pdp__atc');
      if (sticky && atc) {
        var foot = document.querySelector('.mt-footer');
        var ticking = false;
        var update = function () {
          ticking = false;
          var pastAtc = atc.getBoundingClientRect().bottom < 0;
          var footerIn = foot ? foot.getBoundingClientRect().top < window.innerHeight : false;
          sticky.classList.toggle('is-visible', pastAtc && !footerIn);
        };
        var onScroll = function () { if (!ticking) { ticking = true; update(); } };
        window.addEventListener('scroll', onScroll, { passive: true });
        window.addEventListener('resize', onScroll);
        update();
      }
    });
  }

  /* Barra de cuenta atrás: fechas fijas con zona horaria → igual para todos, sin reinicios */
  function initCountdown(root) {
    root.querySelectorAll('[data-mt-countdown]:not([data-mt-init])').forEach(function (bar) {
      bar.dataset.mtInit = '1';
      var start = Date.parse(bar.dataset.start), end = Date.parse(bar.dataset.end);
      if (isNaN(end)) return;
      var design = window.Shopify && window.Shopify.designMode;
      var units = {};
      bar.querySelectorAll('[data-u]').forEach(function (u) { units[u.dataset.u] = u; });
      var pad = function (n) { return (n < 10 ? '0' : '') + n; };
      var timer = null;
      function tick() {
        var now = Date.now();
        if (!design && ((!isNaN(start) && now < start) || now >= end)) {
          bar.hidden = true;
          var sec = bar.closest('.shopify-section'); if (sec) sec.style.display = 'none';
          if (timer) clearInterval(timer);
          return;
        }
        var left = Math.max(0, Math.floor((end - now) / 1000));
        units.d.textContent = pad(Math.floor(left / 86400));
        units.h.textContent = pad(Math.floor(left % 86400 / 3600));
        units.m.textContent = pad(Math.floor(left % 3600 / 60));
        units.s.textContent = pad(left % 60);
        bar.hidden = false;
      }
      tick();
      if (!bar.hidden) timer = setInterval(tick, 1000);
    });
  }

  /* Carga diferida real: las imágenes [data-mt-lazy] no se piden hasta estar a ~300 px de la pantalla */
  var lazyIO = ('IntersectionObserver' in window) ? new IntersectionObserver(function (entries) {
    entries.forEach(function (e) { if (e.isIntersecting) { loadLazy(e.target); lazyIO.unobserve(e.target); } });
  }, { rootMargin: '300px 0px' }) : null;
  function loadLazy(img) {
    if (!img.dataset.src) return;
    if (img.dataset.srcset) img.srcset = img.dataset.srcset;
    img.src = img.dataset.src;
    img.removeAttribute('data-src'); img.removeAttribute('data-srcset'); img.removeAttribute('data-mt-lazy');
  }
  function initLazy(root) {
    root.querySelectorAll('img[data-mt-lazy]').forEach(function (img) {
      if (!lazyIO || (window.Shopify && window.Shopify.designMode)) { loadLazy(img); return; }
      lazyIO.observe(img);
    });
  }

  /* Vídeo (MT – Vídeo): ni el vídeo ni su imagen fija se piden hasta estar a ~200 px; se pausa fuera de pantalla.
     Con "reducir movimiento" no se reproduce solo: se muestran los controles. */
  var vidIO = ('IntersectionObserver' in window) ? new IntersectionObserver(function (entries) {
    entries.forEach(function (e) {
      var v = e.target;
      if (e.isIntersecting) {
        loadVideo(v);
        if (v.dataset.mtAuto === '1') { var p = v.play(); if (p && p.catch) p.catch(function () {}); }
      } else if (v.dataset.mtAuto === '1' && !v.paused) {
        v.pause();
      }
    });
  }, { rootMargin: '200px 0px' }) : null;
  function loadVideo(v) {
    if (v.dataset.mtLoaded) return;
    v.dataset.mtLoaded = '1';
    if (v.dataset.poster) v.poster = v.dataset.poster;
    v.preload = v.dataset.mtAuto === '1' ? 'auto' : 'metadata';
    v.src = v.dataset.src;
  }
  function initVideo(root) {
    root.querySelectorAll('video[data-mt-video]:not([data-mt-init])').forEach(function (v) {
      v.dataset.mtInit = '1';
      v.muted = true;
      var auto = !reduce && v.dataset.autoplay === 'true';
      v.dataset.mtAuto = auto ? '1' : '0';
      if (!auto) v.controls = true;
      if (!vidIO) { loadVideo(v); if (auto) v.play().catch(function () {}); return; }
      vidIO.observe(v);
    });
  }

  /* Entrega estimada: hoy + días hábiles (lunes a viernes). Sin festivos inventados. */
  function initEta(root) {
    root.querySelectorAll('[data-mt-eta]:not([data-mt-init])').forEach(function (el) {
      el.dataset.mtInit = '1';
      var n = function (k) { return parseInt(el.dataset[k], 10) || 0; };
      function addBusinessDays(date, days) {
        var d = new Date(date.getFullYear(), date.getMonth(), date.getDate());
        while (days > 0) { d.setDate(d.getDate() + 1); var w = d.getDay(); if (w !== 0 && w !== 6) days--; }
        return d;
      }
      var today = new Date();
      var start = addBusinessDays(today, n('prepMin') + n('shipMin'));
      var end = addBusinessDays(today, n('prepMax') + n('shipMax'));
      var fmt = function (d) { return d.toLocaleDateString('en-US', { weekday: 'short', month: 'short', day: 'numeric' }); };
      var txt = (el.dataset.text || '').replace('[start]', fmt(start)).replace('[end]', fmt(end));
      var out = el.querySelector('[data-mt-eta-text]');
      if (out) out.textContent = txt;
      el.hidden = false;
    });
  }

  function initAll(e) {
    var root = (e && e.target && e.target.querySelectorAll) ? e.target : document;
    initReveals(root); initHero(root); initSteps(root); initFaq(root); initGallery(root); initOffer(root); initCountdown(root); initEta(root); initLazy(root); initVideo(root);
  }

  /* Carrito lateral: botón "Add a second one" → sube la línea a 2 usando la lógica oficial del tema */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest ? e.target.closest('[data-mt-upsell]') : null;
    if (!btn) return;
    var items = document.querySelector('cart-drawer-items') || document.querySelector('cart-items');
    if (!items || typeof items.updateQuantity !== 'function') return;
    e.preventDefault();
    btn.disabled = true;
    var line = parseInt(btn.dataset.line, 10) || 1;
    /* El tema compara la cantidad devuelta con la de la casilla: la ponemos a 2 antes para evitar
       el falso aviso "You can only add 2 of this item to your cart." */
    var qtyInput = document.getElementById('Drawer-quantity-' + line) || document.getElementById('Quantity-' + line);
    if (qtyInput) qtyInput.value = 2;
    items.updateQuantity(line, 2, e, 'mt-upsell', btn.dataset.variant);
  });

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initAll);
  else initAll();
  document.addEventListener('shopify:section:load', initAll);
})();
